import e from "react";
import { mintelBlue600 as p, cmBlue600 as _ } from "mintel-tokens";
import f from "classnames";
import { u as k } from "./ThemeProvider--i7ESlT5.es.js";
import { u as g, D as v } from "./DarkModeProvider-xoZXm3ct.es.js";
import { T as m } from "./index-Dd-4N6BE.es.js";
import { T as P } from "./Tooltip-B-bmRvX4.es.js";
import { g as T } from "./utils-Ci4OZEP4.es.js";
import './Pill.css';const B = "Pill-module__oval___4Zqye", E = "Pill-module__dark___qpmRl", N = "Pill-module__compere___C1l62", a = {
  oval: B,
  default: "Pill-module__default___fBrCK",
  dark: E,
  compere: N
}, y = ({
  children: t,
  color: s = null,
  multiLineTooltip: n = !1,
  tooltipClassName: c = ""
}) => {
  const o = k(), d = g(), r = {
    compere: _,
    default: p
  }, l = s ?? r[o] ?? r.default, i = T(l, "Card.Pill"), u = /* @__PURE__ */ e.createElement(v, { darkMode: i }, /* @__PURE__ */ e.createElement(
    "div",
    {
      className: f(a.oval, a[o], {
        [a.dark]: d
      }),
      style: { backgroundColor: l },
      tabIndex: 0
    },
    /* @__PURE__ */ e.createElement(m.Heading6, { oneLineTruncate: !0, responsive: !0, tagName: "span" }, t)
  ));
  return /* @__PURE__ */ e.createElement("div", { className: a.container }, /* @__PURE__ */ e.createElement(
    P.Hover,
    {
      dark: !0,
      trigger: u,
      placement: "top",
      accessible: !1,
      short: !0
    },
    /* @__PURE__ */ e.createElement("div", { className: c }, /* @__PURE__ */ e.createElement(
      m.Body2,
      {
        darkBg: !0,
        oneLineTruncate: !n,
        responsive: !0,
        tagName: "span"
      },
      t
    ))
  ));
};
y.displayName = "Pill";
export {
  y as P
};
